import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=9b26051c&scoped=true"
import script from "./reviewList.vue?vue&type=script&lang=js"
export * from "./reviewList.vue?vue&type=script&lang=js"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=9b26051c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b26051c",
  null
  
)

export default component.exports